import * as API from '../utils/API/API';
import { useMutation } from 'react-query';

const Payment = API.payment();

export const useDeleteStripeMutation = (options = {}) =>
  useMutation(['deleteStripe'], ({ accountId }) => Payment.deleteStripeAccount(accountId), options);
